import { render, staticRenderFns } from "./EditCourse.vue?vue&type=template&id=fb649882"
import script from "../../services/teacher/edit-course.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/edit-course.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports